<template>
  <div class="projectOverview">
    <div
      class="index-banner-ruralInfo"
      :class="{ load: ruralBannerList.length === 0 }"
    >
      <div class="swiper-container pic">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="item in ruralBannerList"
            :key="item.id"
          >
            <img class="pc" :src="item.img" alt="" />
          </div>
        </div>
      </div>
      <div class="banner-swiper-pagination">
        <div class="swiper-pagination" v-if="ruralBannerList.length > 1"></div>
      </div>
    </div>
    <div class="rural-info">
      <div class="article-content">
        <div class="article">
          <div class="article-title">
            {{ lan ? "Langtou Ancient Village" : "塱头乡村振兴项目" }}
          </div>
          <div class="article-subtitle">
            {{
              lan
                ? "It was established in the late Southern Song Dynasty and has a history of over seven hundred years."
                : "明清定型，一脉单姓的岭南传统村落"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? "In support of the country’s rural revitalization strategy, in September 2021, the Guangdong Vipshop Philanthropic Foundation and the Huadu District People’s Government of Guangzhou entered a strategic partnership agreement for the Vipshop Rural Revitalization Project in Langtou Village. As a public welfare investment project, Vipshop used cultural revitalization as an entry point for creating a sustainable model of high-quality rural development and the realization of common prosperity in Langtou Village. "
                : "为响应国家乡村振兴战略，2021年9月，唯品会与广州市花都区政府签订塱头村乡村振兴项目战略合作协议。唯品会在塱头村以文化振兴为切入点，通过公益性投入，探索乡村高质量发展、实现共同富裕的可持续模式。"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? "With the north star of promoting fine traditional Chinese culture, the Langtou project team has joined hands with experts and scholars to tackle both village preservation and development. A co-governance model has been introduced to stimulate endogenous growth and empower villagers’ participation. The project aims to help Langtou achieve transformation and rebirth to become the “most traditional yet most dynamic” cultural tourism destination in the Greater Bay Area."
                : "在弘扬中华优秀传统文化的方向指引下，塱头项目团队联合众多专家、学者，引入村民共治模式，以激活古村内生力量为路径，保护与发展并举，助力塱头蝶变新生，使之成为大湾区“最传统、最活力”的新文旅目的地。"
            }}
          </div>
          <div class="article-info">
            {{
              lan
                ? "The Langtou project is the sole rural revitalization project in South China — and one of very few in the entire country — that focuses on cultural revitalization as its core. The project aspires to be the paragon of China’s next-generation rural revitalization efforts. A governance model has been designed to cover the whole project cycle, from construction to operation. Various stakeholders have joined hands in a co-creation process to develop an innovative, market-driven operational model, ensuring that both talents and profits remain in the village and consequently realizing the public benefits of rural revitalization."
                : "作为华南唯一、国内少见的以文化振兴为核心的乡村振兴项目，塱头项目旨在打造新时代中国乡村振兴的精神封面。项目从建设到运营，设计了覆盖全周期的治理模式，通过各方共建打造市场化运作的创新模式，让人才和利润都留在乡村，真正实现乡村振兴的公益价值。"
            }}
          </div>
        </div>
        <div class="rural-img">
          <img class="rural-img-show" src="@/assets/rural1.jpg" alt="" />
          <img class="rural-img-show" src="@/assets/rural2.jpg" alt="" />
          <img class="rural-img-show" src="@/assets/rural3.jpg" alt="" />
          <img class="rural-img-show" src="@/assets/rural4.jpg" alt="" />
        </div>
      </div>
      <div class="share-box">
        <ShareQr :showApplet="false" :showExhibitionInfo="false" :showLodg="false"  />
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import ShareQr from "../components/shareQr.vue";

export default {
  name: "projectOverview",
  components: {
    ShareQr,
  },
  data() {
    return {
      content: "",
      pageIndex: 1,
      ruralBannerList: [],
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    pageIndex(val, oldval) {},
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
      this.init();
    },
  },
  mounted() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
  },
  methods: {
    async init() {
      await this.$api.get(
        "/advert/list",
        { current: 1, pageSize: 10, advertFlagName: "rural_banner" },
        (r) => {
          const { data, code } = r;
          if (code == 0) {
            if (data && data.length > 0) {
              data.forEach((el) => {
                el.img = (el.image && JSON.parse(el.image)[0].src) || "";
              });
              this.ruralBannerList = JSON.parse(JSON.stringify(data));
            }
            this.$nextTick(() => {
              /* eslint-disable no-new */
              new Swiper(".swiper-container", {
                pagination: ".swiper-pagination",
                paginationClickable: true,
                autoplay: false,
                speed: 3000,
                loop: true,
              });
            });
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.index-banner-ruralInfo {
  position: relative;
  min-height: calc(100vw * 0.35);
}
.index-banner-ruralInfo .pic,
.index-banner-ruralInfo img {
  width: 100%;
  height: 20px;
  min-height: 720px;
}
.projectOverview {
  margin-top: 94px;
}
.index-banner-ruralInfo {
  width: 100%;
  height: 720px;
}
.banner-swiper-pagination {
  width: 100%;
  position: relative;
  margin: 0 auto;
}

.swiper-pagination {
  position: absolute;
  right: 0;
  bottom: 40px;
}
.swiper-pagination >>> .swiper-pagination-bullet {
  width: 20px;
  height: 4px;
  border-radius: 0;
  margin: 0;
  padding: 0;
}
.swiper-pagination >>> .swiper-pagination-bullet-active::before {
  height: 0;
}
.index-banner-ruralInfo >>> .swiper-pagination span {
  margin: auto 4px !important;
  opacity: 1;
  width: 20px;
  height: 4px;
  background: url(../../assets/diandian_grey.png) no-repeat center;
  background-size: contain;
  border-radius: 0;
}
.index-banner-ruralInfo
  .swiper-pagination
  >>> .swiper-pagination-bullet-active {
  width: 20px;
  height: 4px;
  background: none;
  position: relative;
  background: url(../../assets/diandian_highllight.png) no-repeat center;
  background-size: contain;
}
.rural-info {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 70px auto 100px;
  background-color: #fff;
}
.article-content {
  width: 100%;
}
.article {
  width: 1060px;
}
.article-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.article-subtitle {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
  margin: 10px 0;
}
.article-info {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 32px;
  font-weight: 400;
  margin-bottom: 30px;
}
.share-box {
  position: absolute;
  right: 0px;
  top: 120px;
}
.rural-img {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 70px;
}
.rural-img-show {
  width: 708px;
  height: 354px;
  margin-bottom: 26px;
}

@media (max-width: 768px) {
}
@media (max-width: 640px) {
}
</style>
